import { ResponsiveTableRow } from '@fs/zion-ui'
import { css } from '@emotion/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { toLocaleString } from '../../../util/DateUtil'
import { GroupLink } from '../../app/Links'
import { DmcResponsiveCheckboxTable } from '../../common/DmcResponsiveTable'
import DeleteGroupUserButton from './buttons/DeleteGroupUserButton'
import DemotePromoteUserButton from './buttons/DemotePromoteUserButton'

const secondaryDataCss = css`
  color: grey;
  font-size: 0.75rem;
`

const endColumnCss = css`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
`

export default function UserGroupsList({ setCheckedGroups, memberSummaries, refreshUserGroupsDataAndControls }) {
  const { t } = useTranslation()

  const selectAllLabel = t('user.groups.selectAll', 'Select All ({ memberSummaryCount })', {
    memberSummaryCount: memberSummaries.length,
  })

  const columnConfig = {
    labels: [selectAllLabel, ''],
    columnWidths: [8, 4],
    combinationRules: [['column1'], ['column2']],
  }

  return (
    <DmcResponsiveCheckboxTable
      id="User Groups List"
      totalColumnCount={2}
      atSizeColumns={{ default: columnConfig }}
      onSelectionChange={setCheckedGroups}
    >
      {memberSummaries.map((memberSummary) => (
        <ResponsiveTableRow
          key={memberSummary.id}
          name={memberSummary.id}
          column1={
            <>
              <GroupLink groupId={memberSummary.id} groupName={memberSummary.name} />
              <div css={secondaryDataCss}>
                {`${t('joined', 'Joined')}: ${toLocaleString(new Date(memberSummary.createDate), false)}
              • ${t('status.label', 'Status')}: ${t(
                `group.memberStatus.${memberSummary.memberStatus}`,
                memberSummary.memberStatus
              )}
              • ${t('types', 'Types')}: ${memberSummary.groupTypes
                ?.map((type) => t(`group.type.${type}`, type))
                .join(', ')}`}
              </div>
            </>
          }
          column2={
            <div css={endColumnCss}>
              <div css={secondaryDataCss}>
                {t('user.groups.sharedReservations', 'Shared Reservations')}: {memberSummary.sharedReservationCount}
              </div>
              <DemotePromoteUserButton
                memberSummaries={[memberSummary]}
                refreshUserGroupsDataAndControls={refreshUserGroupsDataAndControls}
                single
              />
              <DeleteGroupUserButton
                memberSummaries={[memberSummary]}
                refreshUserGroupsDataAndControls={refreshUserGroupsDataAndControls}
                single
              />
            </div>
          }
        />
      ))}
    </DmcResponsiveCheckboxTable>
  )
}
